












import { Vue, Prop, Component } from 'vue-property-decorator';
import Heading2 from '@/components/Atoms/Heading/Heading2.vue';

@Component({
  components: {
    Heading2,
  },
})
export default class Question extends Vue {
  @Prop() inner!: boolean;
}
